<template>
    <div class="feedback">
        <div class="card feedback-header-card">
            <div class="card-header flex flex-between font-bold">
                <div class="card-header-title font-28">问题与意见</div>
                <div class="card-header-right font-24">
                    {{ createform.suggestion.length }}/200
                </div>
            </div>
            <van-field
                v-model="createform.suggestion"
                rows="4"
                autosize
                type="textarea"
                placeholder="请填写10个字以上的问题描述以便我们提供更好的帮助"
                maxlength="200"
                @blur="suggestionBlur"
            />
            <div class="error-message" v-if="suggestionErrorMessage">
                {{ suggestionErrorMessage }}
            </div>
        </div>
        <div class="card feedback-img-card">
            <div class="card-header flex flex-between font-bold">
                <div class="card-header-title font-28">
                    图片（选填，提供问题截图）
                </div>
                <div class="card-header-right font-24">
                    {{ fileList.length }}/4
                </div>
            </div>
            <div class="photo-list">
                <van-uploader
                    :max-count="4"
                    accept="image/*"
                    v-model="fileList"
                    :after-read="afterRead"
                    :max-size="4242880"
                    :multiple="true"
                >
                    <div
                        class="uploader-examples flex flex-center flex-vertical-center"
                    >
                        <img
                            src="../../assets/images/feedback/feedback-upload-icon.png"
                        />
                    </div>
                </van-uploader>
            </div>
        </div>
        <div class="card feedback-phone-card">
            <div class="card-header flex flex-between font-bold">
                <div class="card-header-title font-28">
                    联系电话
                </div>
            </div>
            <div class="phone-input">
                <van-field
                    v-model="createform.contact"
                    ref="phoneInput"
                    type="number"
                    maxlength="11"
                    placeholder="选填,便于我们与你联系"
                    @focus="bootomBtn = false"
                    @blur="bootomBtn = true"
                />
                <div class="error-message" v-if="phoneErrorMessage">{{ phoneErrorMessage }}</div>
            </div>
        </div>
        <footer-button
            btnText="提交"
            :isHabitation="bootomBtn"
            @config="sumitBtn"
        />
    </div>
</template>

<script>
import { Toast } from 'vant'
import FooterButton from '@/components/Button/FooterButton'
import utils from '@/utils/index'
import ajax from '@/api/index'

export default {
    components: {
        FooterButton
    },
    props: {},
    data() {
        return {
            fileList: [], // 图片列表
            createform: {
                contact: '', // 手机号码
                suggestion: '' // 问题与意见
            },
            phoneErrorMessage: '',
            suggestionErrorMessage: '',
            bootomBtn: true
        }
    },
    computed: {
    },
    watch: {
        createform: {
            handler(value) {
                const { contact, suggestion } = value
                if (contact && !/^1[3456789]\d{9}$/.test(contact)) {
                    this.phoneErrorMessage = '请输入正确的手机号码'
                } else {
                    this.phoneErrorMessage = ''
                }
                if (suggestion.length >= 10) {
                    this.suggestionErrorMessage = ''
                }
            },
            deep: true
        },
    },
    mounted() {
        // this.init()
        const clientHeight = document.documentElement.clientHeight
        window.onresize = () => {
            // const { isTrusted } = e
            this.bootomBtn = !(
                document.documentElement.clientHeight < clientHeight
            )
        }
    },
    methods: {
        init() {
            // this.createform.contact = (this.user_info && this.user_info.phone) || ''
        },
        // 文件上传的钩子
        afterRead(file) {
            this.fileUpLoad(file)
        },
        /**
         * @param fileData 文件数据
         * @param type 上传的类型认证
         * 文件上传
         */
        async fileUpLoad(fileData) {
            try {
                Toast.loading({
                    message: '上传中...',
                    forbidClick: true
                })
                const { content } = fileData
                const file = await utils.compress(fileData)
                let formData = new FormData()
                formData.append('file', file)
                formData.append('authImageType', 5)
                const { code, data, message } = await ajax.createUploadFile(
                    formData
                )
                if (code === 200) {
                    const { fileName } = data
                    this.fileList.forEach(item => {
                        if (item.content === content) {
                            item.fileName = fileName
                        }
                    })
                } else {
                    Toast(message)
                }
            } catch (error) {
                // 错误信息
            }
        },
        // 提交btn
        async sumitBtn() {
            const { suggestion } = this.createform
            if (!suggestion || suggestion.length < 10) {
                this.suggestionErrorMessage = !suggestion
                    ? '请输入反馈内容'
                    : '请至少输入10个字'
                return
            }
            if (this.phoneErrorMessage) {
                return
            }
            const fileNames = this.fileList.map(item => item.fileName)
            const { code } = await ajax.createFeedback({
                fileNames,
                ...this.createform
            })
            if (code === 200) {
                Toast.success('提交成功')
                setTimeout(() => {
                    if (this.isWechart) {
                        utils.wxNavigateBack(1)
                    } else {
                        window.location.href = 'https://www.success.pop/'
                    }
                }, 300)
            }
        },
        /**
         * 失去焦点事件
        */
        suggestionBlur() {
            const { suggestion } = this.createform
            if (!suggestion || suggestion.length < 10) {
                this.suggestionErrorMessage = !suggestion
                    ? '请输入反馈内容'
                    : '请至少输入10个字'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.feedback {
    height: 100%;
    background-color: #f0f0f0;
    padding-top: 30px;
    .card {
        background-color: #ffffff;
        padding: 30px;
        .card-header {
            color: #656565;
        }
        .van-cell {
            padding: 20px 0 0;
        }
    }
    .feedback-img-card,
    .feedback-phone-card {
        margin-top: 20px;
    }
    .feedback-phone-card {
        .phone-input {
            border-bottom: 1px solid #e5e5e5;
            padding: 20px 0;
        }
    }
    .feedback-img-card {
        .photo-list {
            padding-top: 40px;
        }
        .uploader-examples {
            border: 2px dashed #e5e5e5;
            width: 160px;
            height: 160px;
            img {
                width: 80px;
                height: 80px;
            }
        }
    }
    .error-message {
        color: red;
        padding-top: 10px;
        font-size: 20px;
    }
    .van-cell:after {
        border-bottom: none;
    }
}
</style>
